const csrfToken = () => document.querySelector('meta[name="csrf-token"]').getAttribute('content')

export { csrfToken }
export default { csrfToken }
